module.exports = __webpack_public_path__ + "img/weather.943bc274.svg";